// import { FlashMessageService, CryptoLocalStorage } from "zoox-infra";
// import { zPayPinForm } from "zoox-components";
// import CompanyService from "@/services/CompanyService";
// import PaymentService from "@/services/PaymentService";
// import PersonService from "@/services/PersonService";
// import OrderService from "@/services/OrderService";
// import PaymentMethod from "@/components/PaymentMethod/PaymentMethod.vue";
// import PaymentCanceled from "@/components/PaymentCanceled/PaymentCanceled.vue";
// import moment from "moment";
// import Vue from "vue";

export default {
  name: "EntryOptions.js",
  components: {
    // "z-pay-pin-form": zPayPinForm,
    // PaymentMethod: PaymentMethod,
    // PaymentCanceled: PaymentCanceled
  },
  data() {
    return {};
  },
  methods: {}
};
